// Article → ONE primary tool cross-links (binding spec §5).
// Rendered as the "Put This Into Practice" module on each article page.
// Format below is read by scripts/test_tools_registry.mjs:
//   <article-slug> -> tool "<ID>"
export const ARTICLE_TOOLS = {
  // market-leaders-expired-assumptions -> tool "M12"
  "market-leaders-expired-assumptions": "M12",
  // growth-not-scaling -> tool "G01"
  "growth-not-scaling": "G01",
  // framework-for-evaluating-market-entry -> tool "C01"
  "framework-for-evaluating-market-entry": "C01",
  // why-product-launches-underperform -> tool "C02"
  "why-product-launches-underperform": "C02",
  // why-distributor-network-underperforming -> tool "C05"
  "why-distributor-network-underperforming": "C05",
  // how-to-diagnose-sales-productivity -> tool "S01"
  "how-to-diagnose-sales-productivity": "S01",
  // when-to-hire-sales-transformation-consultant -> tool "S14"
  "when-to-hire-sales-transformation-consultant": "S14",
  // choosing-route-to-market-strategy -> tool "C03"
  "choosing-route-to-market-strategy": "C03",
  // why-channel-partners-dont-push-your-brand -> tool "C06"
  "why-channel-partners-dont-push-your-brand": "C06",
  // discount-not-deal -> tool "P03"
  "discount-not-deal": "P03",
  // how-to-identify-pricing-leakage -> tool "P02"
  "how-to-identify-pricing-leakage": "P02",
  // why-growth-not-translating-into-profit -> tool "P01"
  "why-growth-not-translating-into-profit": "P01",
  // next-market-leader-different-problem -> tool "M12"
  "next-market-leader-different-problem": "M12",
  // research-that-informs-decisions -> tool "M10"
  "research-that-informs-decisions": "M10",
  // why-marketing-activity-isnt-producing-demand -> tool "S11"
  "why-marketing-activity-isnt-producing-demand": "S11",
  // marketing-budget-question-every-ceo -> tool "B09"
  "marketing-budget-question-every-ceo": "B09",
  // brand-or-performance-false-choice -> tool "B09"
  "brand-or-performance-false-choice": "B09",
  // why-buyers-cant-tell-you-apart -> tool "B03"
  "why-buyers-cant-tell-you-apart": "B03",
  // positioning-is-a-choice-not-a-tagline -> tool "B01"
  "positioning-is-a-choice-not-a-tagline": "B01",
  // why-d2c-acquisition-costs-keep-rising -> tool "D05"
  "why-d2c-acquisition-costs-keep-rising": "D05",
  // how-to-evaluate-performance-marketing-agency -> tool "D15"
  "how-to-evaluate-performance-marketing-agency": "D15",
  // roas-is-not-profit -> tool "D03"
  "roas-is-not-profit": "D03",
  // why-marketplace-revenue-grows-but-profit-doesnt -> tool "D01"
  "why-marketplace-revenue-grows-but-profit-doesnt": "D01",
  // the-marketplace-flywheel -> tool "D09"
  "the-marketplace-flywheel": "D09",
  // what-your-amazon-acos-is-telling-you -> tool "D02"
  "what-your-amazon-acos-is-telling-you": "D02",
};
